/* Filtro para formatação de CNPJ */
angular.module("avlib").filter('avCnpj', function () {
	return function(cnpj){
		if (cnpj != null){
			while (cnpj.length < 14){
				cnpj = "0"+cnpj;
			}
			return (cnpj.substr(0,2)+"."+cnpj.substr(2,3)+"."+cnpj.substr(5,3)+"/"+cnpj.substr(8,4)+"-"+cnpj.substr(12,2)).toUpperCase();
		}
		return null;
	};
});
